module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_rectangular_marco_comida_54.16135ab9.png";